import { Observable } from 'rxjs';
import Axios from 'axios-observable';

const Domain = process.env.REACT_APP_MAIN_API_SERVER;

class WorkflowUsers {
    get() {
        return new Observable(subscriber => {
            Axios.get(Domain + '/colleagues/wf/').subscribe(resp => {
                subscriber.next(resp.data.usernames);
                subscriber.complete();
            });
        })
    }
}
export default new WorkflowUsers();